/**
 * Supported app languages (lowercase labels in UI).
 * RTL: only 'ar' uses RTL layout.
 */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'english' },
  { code: 'hi', label: 'hindi' },
  { code: 'bn', label: 'bengali' },
  { code: 'mr', label: 'marathi' },
  { code: 'te', label: 'telugu' },
  { code: 'gu', label: 'gujarati' },
  { code: 'id', label: 'bahasa indonesia (indonesian)' },
  { code: 'jv', label: 'javanese (bahasa jawa)' },
  { code: 'su', label: 'sundanese (bahasa sunda)' },
  { code: 'zu', label: 'zulu (isizulu)' },
  { code: 'xh', label: 'xhosa (isixhosa)' },
  { code: 'nso', label: 'sepedi (northern sotho)' },
  { code: 'fr', label: 'french' },
  { code: 'es', label: 'spanish' },
  { code: 'pt', label: 'portuguese' },
  { code: 'ar', label: 'arabic' },
]

export const RTL_LANGUAGES = ['ar']

export function isRtl(langCode) {
  return RTL_LANGUAGES.includes(langCode)
}
